import { create } from 'zustand';

export const useStore = create((set, get) => ({
  // auth
  user: JSON.parse(localStorage.getItem('zuno_user') || 'null'),
  setUser: (user) => {
    if (user) localStorage.setItem('zuno_user', JSON.stringify(user));
    set({ user });
  },
  logout: () => {
    localStorage.removeItem('zuno_access');
    localStorage.removeItem('zuno_refresh');
    localStorage.removeItem('zuno_user');
    set({ user: null });
  },

  // theme — Gmail is light-first; user preference still wins
  theme: localStorage.getItem('zuno_theme') || 'light',
  setTheme: (theme) => {
    localStorage.setItem('zuno_theme', theme);
    if (theme === 'dark') document.documentElement.classList.add('dark');
    else document.documentElement.classList.remove('dark');
    set({ theme });
  },
  toggleTheme: () => {
    const next = get().theme === 'dark' ? 'light' : 'dark';
    get().setTheme(next);
  },

  // mail UI state
  activeAccountId: localStorage.getItem('zuno_account') || null,
  setActiveAccount: (id) => { localStorage.setItem('zuno_account', id || ''); set({ activeAccountId: id }); },
  accountFilter: localStorage.getItem('zuno_filter') || 'all',
  setAccountFilter: (v) => { localStorage.setItem('zuno_filter', v); set({ accountFilter: v, selectedUid: null }); },
  activeFolder: 'inbox',
  setActiveFolder: (f) => set({ activeFolder: f, selectedUid: null, selectedAccountId: null, selectedFolder: null }),
  /** Shared list search (saved searches, command palette, MessageList) */
  listSearch: '',
  setListSearch: (q) => set({ listSearch: q || '' }),
  /** Búsqueda de Drive: la escribe el buscador de la barra superior y la lee Drive. */
  driveSearch: '',
  setDriveSearch: (q) => set({ driveSearch: q || '' }),
  selectedUid: null,
  selectedAccountId: null,
  selectedFolder: null,
  openMessage: (accountId, folder, uid) => set({ selectedUid: uid, selectedAccountId: accountId, selectedFolder: folder }),
  setSelectedUid: (uid) => set({ selectedUid: uid }),
  fullscreen: false,
  toggleFullscreen: () => set((s) => ({ fullscreen: !s.fullscreen })),
  setFullscreen: (v) => set({ fullscreen: v }),

  // composer
  composer: { open: false, mode: 'new', data: null },
  openComposer: (mode = 'new', data = null) => set({ composer: { open: true, mode, data } }),
  closeComposer: () => set({ composer: { open: false, mode: 'new', data: null } }),

  // command palette
  paletteOpen: false,
  setPaletteOpen: (v) => set({ paletteOpen: v }),

  // Phase C — floating Zuno chat
  zunoChatOpen: false,
  setZunoChatOpen: (v) => set({ zunoChatOpen: !!v }),

  // notifications
  notifications: [],
  pushNotification: (n) => set((s) => ({ notifications: [{ id: Date.now() + Math.random(), read: false, ...n }, ...s.notifications].slice(0, 50) })),
  setNotifications: (list) => set({ notifications: list }),
  markNotificationsRead: () => set((s) => ({ notifications: s.notifications.map((n) => ({ ...n, read: true })) })),
  soundEnabled: localStorage.getItem('zuno_sound') !== 'off',
  toggleSound: () => set((s) => { const v = !s.soundEnabled; localStorage.setItem('zuno_sound', v ? 'on' : 'off'); return { soundEnabled: v }; }),
  wsStatus: 'disconnected',
  setWsStatus: (s) => set({ wsStatus: s }),

  // view prefs
  /* Tras archivar/eliminar/Spam desde el lector (M32): 'lista' (como siempre) o 'siguiente'. La lista
     publica en `ordenLista` sus filas en el orden en que se ven, para que el lector sepa cuál sigue. */
  trasMover: localStorage.getItem('zuno_tras_mover') === 'siguiente' ? 'siguiente' : 'lista',
  setTrasMover: (v) => { const t = v === 'siguiente' ? 'siguiente' : 'lista'; localStorage.setItem('zuno_tras_mover', t); set({ trasMover: t }); },
  ordenLista: [],
  setOrdenLista: (ordenLista) => set({ ordenLista }),
  threaded: localStorage.getItem('zuno_threaded') === 'on',
  toggleThreaded: () => set((s) => { const v = !s.threaded; localStorage.setItem('zuno_threaded', v ? 'on' : 'off'); return { threaded: v }; }),

  // mobile: single source of truth for folders drawer (avoids dual hamburger menus)
  mobileFoldersOpen: false,
  setMobileFoldersOpen: (v) => set({ mobileFoldersOpen: !!v }),
  toggleMobileFolders: () => set((s) => ({ mobileFoldersOpen: !s.mobileFoldersOpen })),
}));
